// This JavaScript file is created by Cision and holds settings for all our client modules.
// This file works as a config file for all the modules and here you will find general settings 
// and a specific sektion for each module with its access key that is used to fetch the data from our API. 

var cision = cision || {};
cision.websolution = cision.websolution || {};
cision.websolution.settings = cision.websolution.settings || {};

cision.websolution.settings = {
    general: {
        // Settings that apply to all modules
        recaptchaSiteKey: '',
        serviceEndpoint: 'https://publish.ne.cision.com/papi/',
        uiLanguage: 'sv',
        useProxyHandler: false,
        // proxyHandler: 'ProxyCallsHttpHandler.ashx',
        startDate: '',
        endDate: '',
        pageIndex: 0,
        pageSize: 50,
        numberFormatOptions: {
            thousandSeparator: ' ',
            decimalSeparator: ',',
            decimalPrecision: 2
        },
        dateFormatOptions: {
            dateTimeFormat: 'DD MMM YYYY HH:mm',
            dateFormat: 'DD MMM YYYY',
            timeFormat: 'HH:mm'
        },

        // Newsfeed specific settings
        separateFirstRelease: false,
        introMaxLength: 155,
        titleMaxLength: null,
        newsfeedYearsStartYear: 1980,

        // ownership specific settings
        LargestPieShowCount: 25,
        LargestListShowCount: 25,

        // Calendar specific settings
        separateFirstEvent: false,

        // Printed Material specific settings
        printedMaterialCategory: '',
        maxAmountOfItems: 10, // max amount of items a user can order in one request

        // Ticker specific settings
        tickerImageMinus: "Images/down.png",
        tickerImagePlus: "Images/up.png",
        tickerImageUnchanged: "Images/unadjusted.png",

        //Share calculator specific settings
        startDateYear: 2007,

        // Sharegraph specific settings
        chartContainerId: 'sharegraph-container',
        chartTitle: '',
        backgroundImage: '',
        lineWidth: 2,
        gridLineWidth: 0,
        plotBackgroundColor: 'white',
        plotBorderWidth: 0,
        defaultSeriesType: 'spline', //area, areaspline, bar, column, line, pie, scatter, spline, candlestick or ohlc, arearange, areasplinerange and columnrange.
        chartComparison: 'none', /* Default comparison type */
        typeOfChart: 'EndOfDay',
        showHorisontalTicker: false,
        useHighchartsElements: false, // enabling highcharts own exports and range selectors, can be used if cisions custom ones are removed 
        enableLegend: false,
        enableScrollbar: false,
        enableNavigator: true,
        showVolume: true,
        dividendType: 'Annual', // Annual, Bonus, Monthly, Quarterly, HalfYear 
        effectiveYieldSuffix: 'EFFECTIVEYIELD',
        yAxisSize: { share: { top: 0, height: 250 }, volume: { top: 300, height:80 } }, // sizes for the share graph and the volume graph. only applies when volume is displayed
        mainInstruments: [ /* Array of instruments to consider primary while others become Peers and Indexes */
            { symbol: 'CAG', marketPlace: 'FNSE', currency: 'SEK', name: 'C.A.G Group AB' }
        ],
        indexInstruments: [
            { symbol: 'FIRSTNORTHSEK', marketPlace: 'XSTO', currency: 'SEK', name: 'First North All-Share' }
        ],
        peersInstruments: [
            //{ symbol: 'TEL2 B', marketPlace: 'XSTO', currency: 'SEK', name: 'Tele 2' }
        ],
        instrumentColors: [
            //{ uniqueKey: 'TEL2 BXSTOSEK', preferredColor: '#f27b7b' },
            { uniqueKey: 'OMXSPIXSTOSEK', preferredColor: '#4286f4' },
            //{ uniqueKey: 'TEL2 BXSTOSEKVOLUME', preferredColor: '#c46464' }
        ],
        // Displaying releases, reports, insiders and dividend in the graph.
        // If the indicators should be attached to a line in the graph add correct symbol, marketplace and currency as seriesId otherwise it will stick to the bottom
        // shape = squarepin, flag or circlepin
        indicatorsOnSeries: [
            { uniqueKey: 'Regulatory RPT', translationKey: 'TextReport', seriesId: 'CAG', shape: 'circlepin', title: 'R', shapeColor: '#f27b7b', shapeOutlineColor: '#f27b7b', shapeTextColor: 'white' },  
            { uniqueKey: 'Regulatory PRM', translationKey: 'TextPress', seriesId: '', shape: 'circlepin', title: 'P', shapeColor: '#f27b7b', shapeOutlineColor: '#f27b7b', shapeTextColor: 'white' },
            //{ uniqueKey: 'INSIDERS', translationKey: 'TextInsider', shape: 'flag', title: 'INS', shapeColor: '#a4c5fc', shapeOutlineColor: '#4970af', shapeTextColor: 'black' },
            //{ uniqueKey: 'DIVIDEND', translationKey: 'TextDividend', shape: 'squarepin', title: 'U', shapeColor: '#ecefbf', shapeOutlineColor: '#bec18d', shapeTextColor: 'black' }  
        ],
        // Sharegraph releases specific settings
        showReleaseLink: true,
        enableReleasesOnIntraday: true,
        releaseLinkFormatter: 'https://publish.ne.cision.com/Release/ViewReleaseHtml/',

        // Estimates specific settings
        estimateCurrency: '', // should never be necessary, filters out data with specific currency in the same data set 
        field: 'SALES' /* default historical graph choose between SALES/EBIT/DPS/EPS */,
        valuePrefix: '',
        valueSuffix: ' SEK',
        tooltipHeaderEstimate: "Estimate - ",
        tooltipHeaderReal: "Actual - ",
        tooltipDateLabel: "",
        tooltipAmountLabel: "",
        suffixEstimate: ' FC',
        suffixActual: '',
        periodStart: '',
        periodEnd: '',
        dateString: "",
        amountString: "",
        hideEstimateIfActualExists: true,

        //stores data if ownership tab is rendered
        ownershipTabLoaded: [],
        //stores data if estimate tab is rendered
        estimateTabLoaded: [],
        cisionChartsColors: [
            { uniqueKey: 'gray', preferredColor: '#565656' },
            { uniqueKey: 'orange', preferredColor: '#4f758b' },
            { uniqueKey: 'blue', preferredColor: '#890c58' }
        ]
    },

    sharegraph: {
        accessKey: 'F36EE9BE7B5842479F0CF0E9657D356C',
        shareHistoryKey: '5B02FAB3C9334659B9C3F365C376E5A1'
    },

    minisharegraph: {
        accessKey: 'F36EE9BE7B5842479F0CF0E9657D356C'
    },

    ticker: {
        accessKey: '98BB4130693345C496FD0237C541792B'
    },

    orderbook: {
        accessKey: '4F76A4A6D69D44B5A9343519E99BA187'
    },

	sharecalculator: {
        accessKey: 'E3B999AB39524308B86284367E86EDC4'
    },

    newsfeed: {
        accessKey: '753BD305F9C64E4591021862A79D225E'
    },

    mediafeed: {
        accessKey: '753BD305F9C64E4591021862A79D225E'
    },

    dividend: {
        accessKey: '98BB4130693345C496FD0237C541792B'
    },

    insider: {
        accessKey: '9D35823245AC45F799175AAF7C9F6A3D'
    },

    ownership: {
        accessKey: '79B318BC2D6A4088BD690116403614CA'
    },

    estimate: {
        accessKey: '441EC33DF7534A1F9E9708E319A1A607',
        accessKeyTicker: '4F7F3DD44FA34928A4F592D7F772D52C'
    },

    calendar: {
        accessKey: 'AA6EFCAD94EA4F51AF041BC724F2328D'
    },

    printedMaterial: {
        accessKey: '2D28E57C84A3444A802C85E94FB79FAA'
    },

};

// Switch moment language
try {
    moment.locale(cision.websolution.settings.general.uiLanguage);
} catch (e) {
    console.log(e);
}

try {
    Highcharts.setOptions({
        lang: {
            decimalPoint: cision.websolution.settings.general.numberFormatOptions.decimalSeparator,
            thousandsSep: cision.websolution.settings.general.numberFormatOptions.thousandSeparator
        }
    });
} catch (e) {
    console.log(e);
}
